import styled from 'styled-components';

import { ButtonRoundedSmall, LabelRegular } from '@comeon/ui';

import IconButtonClose from '~/components/misc/icon-button-close';

export const HeadWrapper = styled.section`
	align-items: flex-start;
	display: flex;
	gap: 9px;
	justify-content: space-between;
	text-align: left;
	width: 100%;

	svg {
		fill: var(--section-head-main-icon);
		height: 56px;
		margin: 0 auto;
		object-fit: fill;
		width: 56px;
	}

	.page-head__close svg {
		height: 24px;
		width: 24px;
	}
`;

export const SubTitle = styled(LabelRegular)`
	color: var(--new-qd--subtitle-text-color);
	margin: 0 auto;
`;

export const RoundedButtonSecondary = styled(ButtonRoundedSmall)<{ disabled?: boolean }>`
	background: transparent;
	border: 1px solid var(--button-primary-bg, rgba(var(--primary), 1));
	color: rgba(var(--qd-modal-contrast-text), 1);
	font-size: 19px;
	margin: 0;
	min-height: 52px;
	width: 100%;
`;

export const CloseButton = styled(IconButtonClose)`
	align-items: center;
	background-color: var(--new-qd--modal-header-close-icon-bg);
	border-radius: 50%;
	display: flex;
	justify-content: center;
	padding: 4px;

	svg {
		fill: var(--new-qd--modal-header-close-icon-color) !important;
		height: 24px;
		width: 24px;
	}
`;
